import { Box, Drawer, DrawerProps, useMediaQuery } from "@mui/material";
import { styled, SxProps, Theme } from "@mui/material/styles";
import { Children, isValidElement, cloneElement } from "react";

interface StyledWorkflowDrawerProps extends DrawerProps {
    width?: number;
}
const PREFIX = "FlyInDrawer";

// Default panel width every fly-in gets unless it asks for its own. Exported so side panels that
// live in the page (rather than in a drawer) can match the fly-ins instead of guessing a width.
export const FLY_IN_WIDTH = 450;

const classes = {
    paper: `${PREFIX}-paper`,
    paperBigScreen: `${PREFIX}-paperBigScreen`,
};

const StyledDrawer = styled(Drawer, {
    shouldForwardProp: (prop) => prop !== "width",
})<StyledWorkflowDrawerProps>(({ width }) => ({
    [`& .${classes.paper}`]: {
        width: "100%",
    },
    [`& .${classes.paperBigScreen}`]: {
        width: width || FLY_IN_WIDTH,
        overflowX: "hidden",
    },
}));

type Props = {
    isOpen: boolean;
    onClose: any;
    closeDrawer: any;
    children?: any;
    width?: number;
    drawerSx?: SxProps<Theme>;
};

const FlyInDrawer = (props: Props) => {
    const { isOpen, onClose, children, closeDrawer, width, drawerSx } = props;
    const smallScreen = useMediaQuery("(max-width:767px)");

    const childrenWithProps = Children.map(children, (child) => {
        if (isValidElement(child)) {
            return cloneElement(child, { closeDrawer } as any);
        }
        return child;
    });

    return (
        <StyledDrawer
            width={width}
            anchor="right"
            open={isOpen}
            onClose={onClose}
            classes={{ paper: smallScreen ? classes.paper : classes.paperBigScreen }}
            slotProps={{
                paper: {
                    sx: drawerSx,
                },
            }}
        >
            <Box sx={{ height: "100%", position: "relative" }} role="presentation">
                {childrenWithProps}
            </Box>
        </StyledDrawer>
    );
};

export default FlyInDrawer;
